<template>
  <div>
    <cc-editor-min v-model="form['introduction']"></cc-editor-min>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
export default {
  model: {
    prop: "forms",
    event: "change",
  },
  props: {
    formData: Object,
  },
  components: {},
  data() {
    return {
      form: {
        introduction: "",
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit("change", this.form);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.formData.id) {
      this.form.introduction = this.formData.introduction;
    }
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
</style>